(function(){

    puremvc.define
    (
        // CLASS INFO
        {
            name: 'sinewav3.controller.command.state.resuming.ChangedCommand',
            parent: puremvc.SimpleCommand
        },

        // INSTANCE MEMBERS
        {
            execute: function (note) {

                console.log("state/resuming/ChangedCommand: State changed to RESUMING");

                // TODO: implement...

                // Trigger next state
                this.facade.triggerAction( sinewav3.fsm.action.VISUALIZE );

            }
        }
    );

})();